import { RSAA } from 'redux-api-middleware';
import config from 'config';


export const updateInterventionList = (pageSize, page, sorted, filtered, resized, expanded) => {

  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/swim/cycle/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageSize, page, sorted, filtered }),
      types: [
        {
          type: 'UPDATE_CYCLE_SWITCH_LIST_REQUEST',
          payload: { listState: { pageSize, page, sorted, filtered, resized, expanded } }
        },
        'UPDATE_CYCLE_SWITCH_LIST_SUCCESS',
        'UPDATE_CYCLE_SWITCH_LIST_FAILURE'
      ]
    }
  };
};
export const resetError = () => {
  return {
    type: "RESET_ERROR_MESSAGE_CYCLE_SWITCH_LIST"

  }
}
export const updateIndexOnList = (index) => {
  return {
    type: "UPDATE_CYCLE_SWITCH_INDEX_ON_LIST",
    indexOnList: index
  }
}

export const updateSelectedSwitches = (selected) => ({
  type: "UPDATE_SELECTED_SWITCHES",
  payload: selected,
});